import React, { useState, ReactNode } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from '../icons';

interface AccordionProps {
    title: ReactNode;
    children: ReactNode;
    actions?: ReactNode;
    defaultExpanded?: boolean;
    expanded?: boolean;
    onToggle?: (isExpanded: boolean) => void;
    className?: string;
    /** Desativa o hover do cabeçalho. */
    disableHeaderHover?: boolean;
}

export const Accordion: React.FC<AccordionProps> = ({
    title,
    children,
    actions,
    defaultExpanded = false,
    expanded,
    onToggle,
    className = '',
    disableHeaderHover = false,
}) => {
    const [internalExpanded, setInternalExpanded] = useState(defaultExpanded);
    const isExpanded = expanded !== undefined ? expanded : internalExpanded;

    const handleToggle = () => {
        const newState = !isExpanded;
        if (onToggle) onToggle(newState);
        if (expanded === undefined) setInternalExpanded(newState);
    };

    return (
        <div className={`border border-border rounded-xl bg-surface overflow-visible transition-all duration-200 ease-in-out ${className}`}>
            {/* Cabeçalho clicável */}
            <div
                role="button"
                tabIndex={0}
                aria-expanded={isExpanded}
                className={`flex items-center justify-between px-4 py-3 cursor-pointer select-none rounded-xl transition-colors ${
                    disableHeaderHover ? '' : 'hover:bg-surface-subtle'
                }`}
                onClick={handleToggle}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleToggle(); } }}
            >
                <div className="flex items-center gap-2.5">
                    {isExpanded
                        ? <ChevronUpIcon className="w-4 h-4 text-secondary" aria-hidden="true" />
                        : <ChevronDownIcon className="w-4 h-4 text-secondary" aria-hidden="true" />
                    }
                    <span className="font-semibold text-default text-sm">{title}</span>
                </div>

                {actions && (
                    <div onClick={(e) => e.stopPropagation()}>
                        {actions}
                    </div>
                )}
            </div>

            {/* Conteúdo expandido */}
            {isExpanded && (
                <div className="px-4 pb-4 border-t border-border pt-3">
                    {children}
                </div>
            )}
        </div>
    );
};
